export default function PaystackPaymentCard() {
  return (
    <div className="paystack-card">
      <div className="paystack-card-icon">P</div>
      <div className="paystack-card-copy">
        <h4>Secure Payment via Paystack</h4>
        <p>Pay securely with Mobile Money, Visa, Mastercard, or Bank through Paystack.</p>
      </div>
    </div>
  );
}
